// @ts-check
import LiveChannelOnlineRequestService from './service-live-channel-online';
import LiveStreamEventModel from '../../../models/livestream/livestream-event.model';
import { STREAM_PROVIDERS } from '../../../models/livestream/livestream.const';

/**
 * @typedef {{[sid:string]: {tournaments: {[tid:string]:string},name:string,class:string,id:string}}} TLiveStreamGroupSports
 * @typedef {{[tid:string]:LiveStreamEventModel[]}} TLiveStreamGroupTournaments
 * @typedef {{groupedSports: TLiveStreamGroupSports,groupedTournaments: TLiveStreamGroupTournaments,streamId: string}} TLiveStreamGroup
 */

/**
 * Group events by sport
 * @param {TLiveStreamGroup} acc - acumulator
 * @param {LiveStreamEventModel} match - match to add to sport
 */
function groupBySport(acc, match) {
  if (!acc.groupedSports[match.externalSportId]) {
    acc.groupedSports[match.externalSportId] = {
      id: match.externalSportId,
      name: match.sportName,
      class: match.sportClass,
      tournaments: {},
    };
  }
  if (!match.endDate || (match.endDate && match.externalSportId === 'OT')) {
    const cName = match.categoryName || '';
    const dash = match.categoryName && match.tournamentName ? ' - ' : '';
    const tName = match.tournamentName || '';
    acc.groupedSports[match.externalSportId].tournaments[match.externalTournamentId] = `${cName}${dash}${tName}`;
  }
}

/**
 * Group events by tournaments
 * @param {TLiveStreamGroup} acc - acumulator
 * @param {LiveStreamEventModel} match - match to add to tournament
 */
function groupByTournament(acc, match) {
  if (!acc.groupedTournaments[match.externalTournamentId]) {
    acc.groupedTournaments[match.externalTournamentId] = [];
  }
  acc.groupedTournaments[match.externalTournamentId].push(match);
}

/**
 * Get live stream group for given provider id
 * @param {import('../../../models/livestream/livestream.const').TSTREAM_PROVIDERS_VALUES} pid - provider id
 * @returns {Promise<TLiveStreamGroup>} - live stream group object
 */
export const getStreamingMatches = (pid) => new Promise((resolve, reject) => {
  const liveChannelOnlineRequestService = new LiveChannelOnlineRequestService(pid);
  liveChannelOnlineRequestService.execute((resp) => {
    if (!resp.data || !resp.data.slt) {
      return reject();
    }

    /**
     * @type {TLiveStreamGroup}
     */
    const data = resp.data.slt.reduce((acc, m) => {
      const match = new LiveStreamEventModel(m);
      if (match.externalSportId === 'HR' || match.externalSportId === 'DG' || match.externalSportId === 'OT') {
        let tournamentName = match.tournamentName.toLowerCase().replace(' ', '-');
        match.externalTournamentId = tournamentName;
      }

      if (match.externalSportId === 'OT' && !acc.streamId && match.integrationBrokerId === STREAM_PROVIDERS.SIS) {
        acc.streamId = match.streamId;
      }

      groupBySport(acc, match);
      groupByTournament(acc, match);
      return acc;
    }, {
      groupedSports: {},
      groupedTournaments: {},
      streamId: '',
    });
    resolve(data);
  }, reject);
});